import { render, staticRenderFns } from "./CouponListPanel.vue?vue&type=template&id=583dec74&scoped=true&"
import script from "./CouponListPanel.vue?vue&type=script&lang=js&"
export * from "./CouponListPanel.vue?vue&type=script&lang=js&"
import style0 from "./CouponListPanel.vue?vue&type=style&index=0&id=583dec74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583dec74",
  null
  
)

export default component.exports